export default {"src":"/_next/static/media/helping-lg.colour.a89b792b.svg","height":401,"width":555,"blurWidth":0,"blurHeight":0};